import { FC } from 'react';
import graphql from 'babel-plugin-relay/macro';
import { useFragment } from 'react-relay';

import Divider from '@mui/material/Divider';
import Paper from '@mui/material/Paper';
import SidebarBox from 'components/SidebarBox';

import { EntitySidebar_entity$key } from '__generated__/EntitySidebar_entity.graphql';
import CopyableText from 'components/CopyableText';

type Props = {
  entity: EntitySidebar_entity$key;
};

const EntitySidebar: FC<Props> = props => {
  const { entity, children } = props;

  const { uuid, createdAt, updatedAt } = useFragment(
    graphql`
      fragment EntitySidebar_entity on Entity {
        uuid
        createdAt
        updatedAt
      }
    `,
    entity
  );

  return (
    <Paper>
      <SidebarBox label="Objekto ID:">
        <CopyableText>{uuid}</CopyableText>
      </SidebarBox>

      <Divider />
      <SidebarBox label="Sukūrimo data:">{createdAt}</SidebarBox>

      <Divider />
      <SidebarBox label="Paskutinį kartą keista:">{updatedAt}</SidebarBox>

      {!!children && <Divider />}

      {children}
    </Paper>
  );
};

export default EntitySidebar;
